export enum KsefCollectiveIdentifierOperationErrorCode {
    ArgumentException = 'ArgumentException',
    ArgumentNullException = 'ArgumentNullException',
    BadRequestException = 'BadRequestException',
    CollectiveIdentifierAssignmentRejectedException = 'CollectiveIdentifierAssignmentRejectedException',
    KSeFAuthenticationFailedException = 'KSeFAuthenticationFailedException',
    KSeFAuthenticationTimeoutException = 'KSeFAuthenticationTimeoutException',
    KSeFAuthorizationTokenException = 'KSeFAuthorizationTokenException',
    KSeFAuthorizationTokenNotFoundException = 'KSeFAuthorizationTokenNotFoundException',
    KSeFAuthorizationTokenPendingVerificationException = 'KSeFAuthorizationTokenPendingVerificationException',
    KSeFCredentialsNotFoundException = 'KSeFCredentialsNotFoundException',
    KSeFInsufficientPermissionsException = 'KSeFInsufficientPermissionsException',
    KSeFRequestLimitReachedException = 'KSeFRequestLimitReachedException',
    ServiceBusyException = 'ServiceBusyException',
    ServiceNotAvailableException = 'ServiceNotAvailableException',
    ServiceConfigurationNotAllowedException = 'ServiceConfigurationNotAllowedException',
    UnauthorizedException = 'UnauthorizedException',
    UnexpectedException = 'UnexpectedException',
}